import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { environment } from '../../environments/environment';

@Component({
  selector: 'app-splash-screen',
  template: `
    <div
      style="
        display:flex;
        flex-direction:column;
        justify-content:center;
        align-items:center;
        height:100vh;
        text-align:center;
        padding:20px;
      "
    >
      <h2>ExploreMore Bingo</h2>
    </div>
  `,
})
export class SplashScreenComponent implements OnInit {
  constructor(private route: ActivatedRoute) { }
  ngOnInit(): void {
    this.redirectToDeeplink();
  }

  private redirectToDeeplink(): void {
    // Everything after the '?' in the current URL
    const queryString = window.location.search.substring(1); // removes leading '?'

    if (!queryString) {
      console.warn('No query parameters found to redirect.');
      return;
    }

    const domain = environment.deeplink_domain;
    if (!domain) {
      console.error('deeplink_domain is not defined in environment.');
      return;
    }

    // Ensure single slash/query separator between domain and query
    const separator = domain.includes('?') ? '&' : '?';
    const redirectUrl = `${domain}${separator}${queryString}`;

    window.location.href = redirectUrl;
  }
}
